@if (cards().length > 0) {
  <div class="agent-template-picker" [class.agent-template-picker--stale]="!active()">
    @for (card of cards(); track card.templateId) {
      <button type="button" class="agent-template-picker__card" [disabled]="!active()" (click)="choose(card)">
        @if (card.previewImageUrl) {
          <img class="agent-template-picker__thumb" [src]="card.previewImageUrl" [alt]="card.name" loading="lazy" />
        }
        <span class="agent-template-picker__body">
          <span class="agent-template-picker__name">
            {{ card.name }}
            @if (card.isSurvey) {
              <span class="agent-template-picker__badge">{{ "agent.template.survey" | translate }}</span>
            }
          </span>
          @if (card.meta) {
            <span class="agent-template-picker__meta" [title]="card.meta">{{ card.meta }}</span>
          }
          <span class="agent-template-picker__action">{{ "agent.template.use" | translate }}</span>
        </span>
      </button>
    }
  </div>
}
